import { useEffect, useState } from 'react';
import type { StorefrontUpsell } from '@xshop/shared';
import { getProductUpsell } from '../api/client';

// The one order bump the server offers on this product's checkout, or null while it is unknown or absent.
export function useProductUpsell(productId: string): StorefrontUpsell | null {
  const [offer, setOffer] = useState<StorefrontUpsell | null>(null);

  useEffect(() => {
    let cancelled = false;
    setOffer(null);
    // No product chosen yet means there is nothing to look an offer up against; asking anyway is a 400.
    if (!productId) return;
    getProductUpsell(productId)
      .then((found) => {
        if (!cancelled) setOffer(found);
      })
      .catch(() => {
        // A store with no offer and a store whose offer cannot be priced look the same to the shopper:
        // the form renders without a bump rather than showing one the order would not honour.
        if (!cancelled) setOffer(null);
      });
    return () => {
      cancelled = true;
    };
  }, [productId]);

  return offer;
}
